import { printDebugLog } from "../../constants/Constants";

const loadRazorpayScript = () => {
    return new Promise((resolve) => {
        const script = document.createElement('script');
        script.src = 'https://checkout.razorpay.com/v1/checkout.js';
        script.onload = () => {
            resolve(true);
        };
        script.onerror = () => {
            resolve(false);
        };
        document.body.appendChild(script);
    });
};


export const DisplayRazorpay = async (authUser, pgId, finalAmtInPaisa,
    onlinePaymentTransactionId, mCurrency, payeeName, order_name,
    selectedAddress, showActionToast, onSuccess) => {
    printDebugLog("displayRazorpay", "pgId: " + pgId
        + " finalAmtInPaisa: " + finalAmtInPaisa + " onlinePaymentTransactionId: " + onlinePaymentTransactionId)
    const res = await loadRazorpayScript();

    if (!res) {
        alert('Razorpay SDK failed to load. Please check your connection.');
        return;
    }

    const options = {
        key: pgId, // Replace with your Razorpay key ID
        amount: finalAmtInPaisa, // Amount is in currency subunits. 50000 refers to 50000 paise or INR 500
        currency: mCurrency,
        name: payeeName,
        description: `Pay ${finalAmtInPaisa} for ${order_name}  order`, //Add Donation Here
        image: 'https://www.snpnextgen.com/logo.png', // Replace with your logo URL
        order_id: onlinePaymentTransactionId, // This is a sample Order ID. Replace with your generated Order ID from your backend.
        handler: function (response) {
            // alert(response.razorpay_payment_id);
            // alert(response.razorpay_order_id);
            // alert(response.razorpay_signature);
            printDebugLog("displayRazorpay success", response.razorpay_payment_id,
                response.razorpay_order_id, response.razorpay_signature
            );
            showActionToast({
                title: "Success!",
                message: `Payment is done.\nPayment reference id ${response.razorpay_payment_id}.\nPlease logout & login again to refresh the changes`,
                positive: "Ok",
                positiveAction: () => onSuccess(),
            });
            //Handle success logic here
        },
        prefill: {
            name: authUser?.userName,
            email: authUser?.userEmail,
            contact: authUser?.phone,
        },
        notes: {
            address: selectedAddress,
        },
        theme: {
            color: '#00333E',
        },
        modal: {
            ondismiss: function () {
                //alert('Payment process was cancelled.');
                printDebugLog("displayRazorpay cancel by user");
                showActionToast({
                    title: "Cancelled!",
                    message: "You've cancelled your payment Do you want to try again?",
                    positive: "Yes",
                    positiveAction: () => DisplayRazorpay(pgId, finalAmtInPaisa,
                        onlinePaymentTransactionId, mCurrency, payeeName, selectedAddress, showActionToast, onSuccess),
                    negative: "Cancel",
                });
                // Handle the modal dismiss event (like close button, back button, etc.)
            },
        },
    };

    const rzp1 = new window.Razorpay(options);
    rzp1.on('payment.failed', function (response) {
        // alert(`Payment failed with error code: ${response.error.code}`);
        // alert(response.error.description);
        // alert(response.error.source);
        // alert(response.error.step);
        // alert(response.error.reason);
        // alert(response.error.metadata.order_id);
        // alert(response.error.metadata.payment_id);
        printDebugLog("displayRazorpay failed", response.error.metadata.payment_id,
            response.error.metadata.order_id, response.error.description, response.error.source
            , response.error.code, response.error.step, response.error.reason
        );

        showActionToast({
            title: "Failed!",
            message: `Payment failed due to ${response.error.reason} (Error Code: ${response.error.code})`,
            positive: "Try again",
            positiveAction: () => DisplayRazorpay(pgId, finalAmtInPaisa, onlinePaymentTransactionId,
                mCurrency, payeeName, selectedAddress, showActionToast, onSuccess),
            negative: "Cancel",
        });

        // Handle the failed payment response here
    });
    rzp1.open();
};